import { module } from 'modujs';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { ENV } from '../config.js';

export default class extends module {
    constructor(m) {
        super(m);
        this.minHeight = null;
    }

    init() {
        this.swiper = new Swiper(this.el.querySelector('.swiper'), {
            slidesPerView: 1,
            spaceBetween: 10,
            allowTouchMove: ENV.IS_TOUCH,
            breakpoints: {
                480: {
                    slidesPerView: 4,
                    spaceBetween: 20
                },
            },
            on: {
                init: () => {
                    setTimeout(() => {
                        this.updateHeight();
                    }, 200);

                    window.addEventListener("resize",() => {
                        this.minHeight = 1;
                        this.el.querySelector('.swiper').style.setProperty('--minHeight', this.minHeight + 'px');
                        this.updateHeight();
                    });
                }
            },
            modules: [Navigation],
            navigation: {
                nextEl: this.el.querySelector('.m-solutions-slider_nav.-next'),
                prevEl: this.el.querySelector('.m-solutions-slider_nav.-prev'),
            }
        });
    }

    updateHeight() {
        this.el.querySelectorAll('.c-solution_front, .c-solution_back').forEach((elt) => {
            let b = elt.getBoundingClientRect();
            if (this.minHeight == null || this.minHeight < b.height) {
                this.minHeight = b.height;
            }
        });

        this.el.querySelector('.swiper').style.setProperty('--minHeight', this.minHeight + 'px');
    }
}
